<template>
  <div class="home">
    <aplayer autoplay
      :music="firstSong"
      :list="allSongs" 
      :shuffle="true" 
      :repeat="repeat-all"
    />
    <TimelineGallery/>
  </div>
</template>

<script>
// @ is an alias to /src
import TimelineGallery from '@/components/TimelineGallery.vue';
import Aplayer from 'vue-aplayer';
import _ from 'lodash';

export default {
  name: 'home',

  data: function () {

    var allSongs = [
        { src: '/audio/edith_1.mp3' },
        { src: '/audio/edith_2.mp3' },
        { src: '/audio/louis_1.mp3' },
        { src: '/audio/louis_2.mp3' },
        { src: '/audio/sidney_1.mp3' },
        { src: '/audio/sidney_2.mp3' },
        { src: '/audio/tchaikovsky_1.mp3' },
        { src: '/audio/tchaikovsky_2.mp3' }
      ];

    return {
      firstSong: _.sample(allSongs),
      allSongs: allSongs
    }
  },  
    
  components: {
    TimelineGallery,
    Aplayer
  }
}
</script>

<style lang="scss">
  html,
  body {
    overflow: hidden;
  }

  body {
    margin: 0;
    &::-webkit-scrollbar { 
      display: none;
      width: 0 !important; 
    }
  }

  .aplayer {
    display: none;
  }
</style>